import { 
	IDictionary, 
	ClientFeature 
} from 'util/domain';

interface SettingsFeature {
	enabled:boolean;
	dateToggled?:string;
}

const transformer = (name:string, feature:SettingsFeature):ClientFeature => {
	let { enabled, dateToggled } = feature;
    return {
        name,
        enabled,
        dateToggled : angular.isDefined(dateToggled) ? new Date(dateToggled) : null
    };
};

interface SettingsJson {
	serverPaths:{
		apiPath:string,
		webPath:string,
		adminPath:string,
		helpPath:string,
		legalPath:string,
		helpForumPath:string,
		submitIssuePath:string;
		eventRelayPath:string;
	},
	idp:{
		web: {
			clientId:string,
			path:string;
			scope:string[];
		},
		hybrid: {
			clientId:string,
			path:string;
			scope:string[];
		}
	},
	desktopPollInterval:string,
	desktopPath:string,
	desktopPorts:string,
	maxFileSize:string,
	maxEmailLogoFileSize:string,
	analyticExperimentIds:IDictionary<string>,
	googleIds: {
		analytics:string;
		optimize:string;
		tagManager:string;
	}
	features:IDictionary<SettingsFeature>;
	surveyExpiration?:string;
}

// https://regex101.com/r/dgs38U/3
const uriEndRegex = /\/(\w+\.\w+)(\?[\w=&]*)?$/gi;

export default class SettingsService {
	public static $inject= [
		'SITE_SETTINGS'
	];

	public readonly serverAPIPath = this.SITE_SETTINGS.serverPaths.apiPath;
	public readonly adminPath = this.SITE_SETTINGS.serverPaths.adminPath;
	public readonly serverWebPath = this.normalizeClientUrl(this.SITE_SETTINGS.serverPaths.webPath);
	public readonly serverLegalPath = this.SITE_SETTINGS.serverPaths.legalPath;
	public readonly serverHelpPath =  this.SITE_SETTINGS.serverPaths.helpPath.replace(uriEndRegex, '/');
	public readonly helpForumPath = this.SITE_SETTINGS.serverPaths.helpForumPath;
	public readonly submitIssuePath = this.SITE_SETTINGS.serverPaths.submitIssuePath;
	public readonly desktopPollInterval = +this.SITE_SETTINGS.desktopPollInterval;
	public readonly desktopPorts = this.SITE_SETTINGS.desktopPorts;
	public readonly maxFileSize = +this.SITE_SETTINGS.maxFileSize;
	public readonly idp = this.SITE_SETTINGS.idp;
	public readonly desktopPath = this.SITE_SETTINGS.desktopPath;
	public readonly surveyExpiration = new Date(this.SITE_SETTINGS.surveyExpiration);
	public readonly features:ClientFeature[] = [];
	public readonly maxEmailLogoFileSize = +this.SITE_SETTINGS.maxEmailLogoFileSize;
	public readonly analyticExperimentIds = this.SITE_SETTINGS.analyticExperimentIds;
	public readonly googleIds = this.SITE_SETTINGS.googleIds;
	public readonly eventRelayPath = this.SITE_SETTINGS.serverPaths.eventRelayPath;

	constructor(
		private readonly SITE_SETTINGS:SettingsJson
	){
		if (this.SITE_SETTINGS.features) {
			this.features = Object
				.keys(this.SITE_SETTINGS.features)
				.map(name => transformer(name, this.SITE_SETTINGS.features[name]));
		}
	}

	/**
	 * Normalizes the provided URL to always end in a hash character irrespective
	 * of original format.
	 * @param url The URL to normalize.
	 */
	private normalizeClientUrl(url:string){
		// https://regex101.com/r/pFQn4y/1
		const endsWithHash = /\/(#|#\/)?$/gi;
		if(url.match(endsWithHash)){
			url = url.replace(endsWithHash, '');
		}
		url += '/#';

		return url;
	}
}


// WEBPACK FOOTER //
// ./src/phoenix/services/settingsService.ts